// extracted by mini-css-extract-plugin
module.exports = {"emphasizedText":"az_TI","headline":"az_UI"};